import { createBrowserHistory } from 'history/';

export default createBrowserHistory()


// WEBPACK FOOTER //
// ./src/history.js